import script from "./SearchWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchWidget.vue?vue&type=script&setup=true&lang=js"

import "./SearchWidget.vue?vue&type=style&index=0&id=1d60f4f5&lang=scss"

const __exports__ = script;

export default __exports__